import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";

console.log("ENV FILE", {
    NODE_ENV: process.env.NODE_ENV,
    CLIENT_ID: process.env.REACT_APP_CLIENT_ID,
    TENANT_ID: process.env.REACT_APP_TENANT_ID,
    LOGIN_URL: process.env.REACT_APP_START_LOGIN_PAGE_URL,
  });

const container = document.getElementById("root");
const root = createRoot(container);



root.render(<App />);
